export const investmentTypes = Object.assign({
  DEBIT: 'debit',
  PREPAY: 'prepay',
});

Object.freeze(investmentTypes);

export default investmentTypes;



// WEBPACK FOOTER //
// ./src/enum/bridgeSigning/BridgeSigningEnum.js